import * as React from 'react';
/**
 *
 * Original name: money
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29939%3A7047
 *
 */
export const MoneyPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M32 38c-4.038 0-6-1.962-6-6s1.962-6 6-6 6 1.962 6 6-1.962 6-6 6Zm-12-4c-1.346 0-2-.654-2-2s.654-2 2-2 2 .654 2 2-.654 2-2 2Zm24 0c-1.346 0-2-.654-2-2s.654-2 2-2 2 .654 2 2-.654 2-2 2Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 48V16h42v32H11Zm30.835-28c1.16 2.86 3.535 4.477 7.165 4.892v14.216c-3.63.415-6.005 2.032-7.165 4.892h-19.67c-1.16-2.86-3.535-4.477-7.165-4.892V24.892c3.63-.415 6.005-2.032 7.165-4.892h19.67Z", fill: "currentColor" })));
